module.exports = __webpack_public_path__ + "img/刷新2.59e2e1ba.svg";